import React,{Component} from 'react';
import {PostData} from '../../service/postData';
import {sendNotification} from '../../_notificationSettings/notificationPanel';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import { Loader } from '@progress/kendo-react-indicators';

export default class FooterPage extends Component{
    constructor(props){
        super(props);
        this.state={
            mobile_for_download_link: '',
            isLoading: false,
            visibleSendLink: false,
            mailsendTitle: '',
            mailsendMessage: '',
        }
    }

    //componentDidMount(){}


    handleChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        switch (name) {
            case 'mobile_for_download_link':
                if (/^\d*$/.test(value)) {
                    if (value.length >= 0 && value.length <= 10) {
                        this.setState({ mobile_for_download_link: value });
                    }
                }
                break;
            default:
                break;
        }
    }


      
    getDownloadLink = (event) => {
        event.preventDefault();
        const regex = /^\d{10}$/;
        if(regex.test(this.state.mobile_for_download_link)){
            this.setState({isLoading: true});
            const requestData = JSON.stringify({
                contact: this.state.mobile_for_download_link,
            });
            
            PostData(global.sendAppDownloadMail, requestData,'POST').then((result) => {
                if(result.success == true)
                {    console.log('result', JSON.stringify(result))
                    this.setState({mobile_for_download_link: ''});
                    this.setState({
                        visibleSendLink: true,
                        mailsendTitle: result.title,
                        mailsendMessage: result.message,
                    });
                }
                else
                {
                    sendNotification("Error Message 😓","Some error occured. Please try again.","danger");
                }
            }).finally(() => {
                this.setState({isLoading: false});
            });
        }else{
            alert('Mobile number is invalid.')
        }
    }

    toggleSendLinkDialog = () => {
        this.setState({visibleSendLink: false})
    }

    render(){
        return (
            <React.Fragment>
                <section className="footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="space2">
                                    <img src={global.webUrl+"websiteFilesFolder/img/logo.png"} alt="" title="" />
                                </div>
                                <div>
                                    <div className="icon">
                                        <span><i className="fas fa-map-marker-alt"></i></span>
                                    </div>
                                    <div className="content">
                                        <p>
                                            <a style={{color: '#000'}}  target="_blank" href="http://maps.google.com/?q=29/2, South Tukoganj, Near Bhoraskar Hospital, Indore(MP)-452001">29/2, South Tukoganj, Near Bhoraskar Hospital, Indore(MP)-452001</a>
                                        </p>
                                    </div>
                                    <div className="clearfix"></div>
                                </div>
                                <div>
                                    <div className="icon">
                                        <span><i className="fas fa-phone-alt"></i></span>
                                    </div>
                                    <div className="content">
                                        <p style={{marginTop: 10}}>
                                            <a style={{color: '#000'}} href="tel:+919755299999">+91 9755299999</a><br/><br/>
                                        </p>
                                    </div>
                                    <div className="clearfix"></div>
                                </div>
                                <div>
                                    <div className="icon">
                                        <span><i className="fas fa-envelope"></i></span>
                                    </div>
                                    <div className="content">
                                        <p>
                                            <b>Support & Marketing</b><br/>
                                            <a style={{color: '#000'}} class="mailto" href="mailto:info@vyavsay.in">info@vyavsay.in</a>
                                        </p>
                                    </div>
                                    <div className="clearfix"></div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <h2 className="txt-style-5">Quick Links</h2>
                                <span className="line line1"></span>
                                <ul className="futer">
                                    <li><a href={global.webUrl}>Home</a></li>
                                    <li><a href={global.webUrl+"about-us/"}>About Us</a></li>
                                    <li><a href={global.webUrl+"pricing/"}>Pricing</a></li>
                                    <li><a href={global.webUrl+"faq/"}>FAQ</a></li>
                                    <li><a href={global.webUrl+"blogs/"}>Blogs</a></li>
                                    <li><a href={global.webUrl+"privacy-policy/"}>Privacy Policy</a></li>
                                    <li><a href={global.webUrl+"contact/"}>Contact Support</a></li>
                                    <li><a href={global.webUrl+"demo-videos/"}>Demo Videos</a></li>
                                    <li><a href={global.webUrl+"partner-with-us/"}>Partner With Us</a></li>
                                    <li><a href={global.webUrl+"terms-condition/"}>Terms & Conditions</a></li>
                                </ul>
                            </div>
                            <div className="col-lg-4">
                                <h2 className="txt-style-5">Get Download Link</h2>
                                <span className="line line1"></span>
                                <form className="banner_form">
                                    <input type="text" name='mobile_for_download_link' onChange={this.handleChange} value={this.state.mobile_for_download_link} placeholder="Enter Mobile No." />
                                    <button onClick={this.getDownloadLink}>Go</button>
                                    <div className="clearfix"></div>
                                </form>
                                <br/><br/>
                                <h2 className="txt-style-5">Follow Us</h2>
                                <span className="line line1"></span>
                                <ul className="social">
                                    <li><a href={'https://www.facebook.com/people/Vyavsay/61578016963122/'} target='blank'><i className="fab fa-facebook-f"></i></a></li>
                                    <li><a><i className="fab fa-twitter"></i></a></li>
                                    <li><a><i className="fab fa-youtube"></i></a></li>
                                    <li><a><i className="fab fa-linkedin-in"></i></a></li>
                                    <li><a href={'https://www.instagram.com/vyavsaay/'} target='blank'><i className="fab fa-instagram"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="copyright">
                    <p>Copyright @ 2024. All Rights Reserved</p>
                </section>
                
               
                {this.state.visibleSendLink && (
                    <Dialog title={"Success"} onClose={() => this.toggleSendLinkDialog()}>
                    <p style={{
                    margin: "25px",
                    textAlign: "center",
                  }} dangerouslySetInnerHTML={{ __html: this.state.mailsendMessage }}></p>
                    <DialogActionsBar>
                        <Button type="button" onClick={() => this.toggleSendLinkDialog()}>
                        Ok
                        </Button>
                    </DialogActionsBar>
                    </Dialog>
                )}
                {
                    this.state.isLoading && (
                        <Dialog >
                        <Loader type="converging-spinner" />
                        </Dialog>
                    )
                }
            </React.Fragment>
        );
    }
}